import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import ErrorComp from "components/Error/Error";
import PaymentProgress from "components/PaymentProgress";
import fetcher from "dataProvider";
import { useEffect } from "react";
import { useAppSelector } from "redux/store";

const PHONEPE = () => {
  const { gatewayDetails } = useAppSelector((state) => state.gatewayInfo);
  const { entityId, skipState } = useAppSelector((state) => state.userInfo);

  const payload = gatewayDetails.find(
    (gateway) => gateway.gatewayType === "PHONEPE"
  )?.payload;

  const { mutate, isError, error } = useMutation((mutateData: any) =>
    fetcher.put(`/api/v1/payment/webhook`, mutateData, undefined, {
      "entity-id": entityId,
      "skipState": skipState,
    })
  );

  useEffect(() => {
    mutate(
      {
        ...payload,
        gatewayType: "PHONEPE",
      },
      {
        onSuccess: (res) => {
          window.parent.location.href = res?.data?.transaction?.requestUrl;
        },
      }
    );
  }, [mutate, payload]);

  if (isError) {
    return <ErrorComp message={(error as AxiosError<{ message: string }>)?.response?.data?.message} />
  }
  return <PaymentProgress />;
};

export default PHONEPE;
